module.exports = __webpack_public_path__ + "fonts/IGUIBetav9.a0f17de3.eot";